import "css/Graph.css"
import {MemoizedGraphCell} from "components/graph/GraphCell"
import {DownOutlined} from "@ant-design/icons"
import {Button, Tooltip} from "antd"
import {useSelector, useDispatch} from "react-redux"
import {Table} from "antd"
import {includedSelector, sortDrugsAlphabetically} from "redux/graphSlice"
import DrugHeader from "components/graph/DrugHeader"
import EffectHeader from "components/graph/EffectHeader"
import {dataService} from "services/data.service"
import { useTranslation } from 'react-i18next';

const screenWidth = window.innerWidth
const headerWidth = 310
const minPlotWidth = 400
const maxPlotWidth = 800

export default function Graph({takenBefore = [], wouldTakeAgain = [], wouldNotTakeAgain = []}) {
	const { t } = useTranslation();
	const dispatch = useDispatch(); // Use useDispatch here
	const {drugs, effects} = useSelector(includedSelector)
	const rowClassName = (record, index) => {
		return index === 0 ? 'first-row' : '';
	};
	const columns = effects?.map(effect =>
		column(effect, scale(effect, drugs, effects.length), drugs[drugs.length - 1], t))

	columns.splice(0, 0, drugHeaderColumn(takenBefore, wouldTakeAgain, wouldNotTakeAgain, dispatch, t))

	return (
		<div className="main-graph">
			<Table
				className="graph-table"
				dataSource={drugs}
				scroll={{x: effects.length * minPlotWidth + headerWidth}}
				columns={columns}
				pagination={false}
				//style={{maxWidth: maxPlotWidth * effects.length + headerWidth + 100}}
				sticky
				rowClassName={rowClassName} // Add this line here
			/>
		</div>
	)
}

function drugHeaderColumn(takenBefore = [], wouldTakeAgain = [], wouldNotTakeAgain = [], dispatch, t) {
	const handleSortDrugs = () => {
		dispatch(sortDrugsAlphabetically());
	};
	function css(drug) {
		if (wouldTakeAgain.includes(drug)) {
			return "wouldTakeAgain"
		} else if (wouldNotTakeAgain.includes(drug)) {
			return "wouldNotTakeAgain"
		} else if (takenBefore.includes(drug)) {
			return "takenBefore"
		}
	}

	return {
		title: (
			<Tooltip title={t('tooltips.sortDrugsAlphabetically')} showArrow={false}>
				<Button
					className="sort-button"
					size="large"
					type="text"
					onClick={handleSortDrugs}
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						width: '100%',
					}}
				>
					<DownOutlined style={{ marginRight: 8 }} />
					<span>{t('drugs')}</span>
				</Button>
			</Tooltip>
		),
		width: headerWidth,
		align: "center",
		fixed: 'left', // This line makes the column sticky to the left
		render: drug => <DrugHeader drug={drug} cssClass={css(drug)}/>
	}
}

function column(effect, scale, lastDrug) {
	return {
		title: <EffectHeader effect={effect} width={scale.width}/>,
		render: (text, drug) =>
			<MemoizedGraphCell effect={effect} drug={drug} scale={scale} last={drug === lastDrug}/>
	}
}

function scale(effect, drugs, effectNumber) {
	const rawMax = Math.max(...drugs
		.map(drug => dataService.getDatapoint(drug, effect))
		.map(datapoint => datapoint.ci_up)
	)
	const max = Math.max(2, Math.ceil(rawMax))

	const width = Math.min(maxPlotWidth, Math.max(minPlotWidth, (screenWidth - headerWidth) / effectNumber))

	return {
		max: max,
		width: width
	}
}

